import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { DiscountBlock } from '../DiscountBlock';
import { SubscriptionCard } from '../SubscriptionCard';
import { PaymentInformationBlock } from '../PaymentInformationBlock';
import { CancelAnytimeBlock } from '../CancelAnytimeBlock';
import styles from './SubscriptionPlanSelector.css';

const cx = classnames.bind(styles);

function getDisclaimerText(subscriptionData) {
    const weeks = subscriptionData.billingPeriod?.value;

    if (subscriptionData.trial) {
        const trialDuration = subscriptionData.trialDuration;
        const trialUnit = trialDuration === 1 ? 'week' : 'weeks';

        return `You are enrolling in a ${trialDuration}-week trial subscription to Boundly. You agree to be charged ${subscriptionData.trial.price} now for the first ${trialDuration} ${trialUnit}, then ${subscriptionData.price} every ${weeks} weeks on a recurring basis until you cancel your subscription. The payment will be charged to the card provided above.`;
    }

    return `You are enrolling in a ${weeks}-week subscription to Boundly. You agree to be charged ${subscriptionData.price} per ${weeks} weeks on a recurring basis until you cancel your subscription. The payment will be charged to the card provided above.`;
}

function SubscriptionPlanSelector({ className = '', plans, onSubmit, selectedSubscriptionData, selectSubscription, isPending = false, expiryTimestamp, onExpirePromo, isExpired, hasPaymentInformation = true }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const radioGroupName = useId();

    return (
        <div className={classes}>
            <DiscountBlock
                expiryTimestamp={expiryTimestamp}
                onExpirePromo={onExpirePromo}
                isExpired={isExpired}
            />
            <div className={styles.plans}>
                {plans.map(plan => (
                    <SubscriptionCard
                        subscriptionData={plan}
                        selectedSubscriptionData={selectedSubscriptionData}
                        selectSubscription={selectSubscription}
                        isExpired={isExpired}
                        name={radioGroupName}
                        key={plan.plan}
                    />
                ))}
            </div>
            <p className={styles.disclaimer}>{getDisclaimerText(selectedSubscriptionData)}</p>
            <Button
                type='accent'
                label='Subscribe'
                onClick={() => onSubmit(selectedSubscriptionData)}
                className={cx('button', 'animation')}
                isLoading={isPending}
            />
            <CancelAnytimeBlock />
            {hasPaymentInformation && <PaymentInformationBlock label='pay securely' />}
        </div>
    );
}

SubscriptionPlanSelector.propTypes = {
    className: PropTypes.string,
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isPending: PropTypes.bool,
    expiryTimestamp: PropTypes.any,
    onExpirePromo: PropTypes.func,
    isExpired: PropTypes.bool,
    hasPaymentInformation: PropTypes.bool
};

export {
    SubscriptionPlanSelector
};
